// Version configuration
// This file is auto-updated during the build process
export const VERSION = '1.10.0';